const transcribeAgentAudio = async ({ blob, store }) => {
	const formData = new FormData();

	formData.append('file', blob, 'composer-audio.webm');
	formData.append('model', 'gpt-transcribe');
	formData.append('response_format', 'json');

	const response = await store.request({
		method: 'POST',
		url: '/workspace/inference/audio/transcriptions',
		data: formData,
	});

	if (typeof response === 'string') return response;
	if (response.text) return response.text;

	throw new Error('Transcription response did not include text.');
};

export { transcribeAgentAudio };
